<template>
  <div class="list" name="info">
    <el-card class="searchCard" shadow="never">
      <list-search @search="buttonSearch" :search-loading="checkLoading" :hide-expire-export="hideExpireExport"></list-search>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 列表模块 -->
      <el-table
        stripe
        style="border-radius:10px"
        align="center"
        v-loading="saleLoading"
        :data="sale_list"
        :header-cell-style="{background:'#FAFAFA'}"
        @sort-change="tableSortChange">
        <el-table-column
          prop="shopId"
          label="门店编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="shopName"
          label="门店名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="商户编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="organizationName"
          label="上级机构名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="organizationId"
          label="上级机构编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="statusDesc"
          label="审核状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="tradeStatusStr"
          label="交易状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="settleStatusStr"
          label="结算状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="profileFromHead"
          label="信息是否与总部一致"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.profileFromHead === 0 ? '不一致': '一致' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="fSettleStateStr"
          label="刷卡权限"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.posRefund === 0 && scope.row.transaction === 0 ? '刷卡退款关闭/刷卡T0开通': '刷卡退款开通/刷卡T0关闭' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="d0StatusStr"
          label="是否开通D0权限"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          width="300"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
            <auth-button
              type="text"
              opt="details"
              v-if="(scope.row.fAgentId !== agentId && scope.row.fOperator !== userName && scope.row.fOperator !== agentId) || scope.row.statusDesc === '待审核' || scope.row.statusDesc === '人工审核'"
              @click.native="handleSale(scope.$index, scope.row)"
              label="查看"></auth-button>
            <auth-button
              type="text"
              opt="edit"
              v-if="(scope.row.fAgentId === agentId || scope.row.fOperator === userName || scope.row.fOperator === agentId) && (scope.row.statusDesc === '审核不通过' || scope.row.statusDesc === '审核通过' || scope.row.statusDesc === '资料待完善')"
              @click.native="handleEditSale(scope.$index, scope.row)"
              label="编辑">
            </auth-button>
            <auth-button
              type="text"
              opt="update_expired"
              v-if="(scope.row.fAgentId === agentId || scope.row.fOperator === userName || scope.row.fOperator === agentId) && scope.row.cardExpiredFlag"
              @click.native="handleUpdate(scope.$index, scope.row)"
              label="证件更新"></auth-button>
            <auth-button
              type="text"
              opt="settle_card_edit"
              class="btmBtn"
              v-if="scope.row.profileFromHead === 0 && scope.row.statusDesc  && scope.row.statusDesc === '审核通过' && scope.row.shopTypeName !== '直营分店'"
              @click.native="settleCardEdit(scope.$index, scope.row)"
              label="结算卡快速修改">
            </auth-button>
            <!-- <auth-button
              class="btmBtn"
              type="text"
              opt="join_blue_sea"
              v-if="scope.row.statusDesc === '审核通过' && scope.row.blueSeaStatus !== 3"
              :disabled="scope.row.blueSeaStatus === 1"
              @click.native="handleJoinBlueSea(scope.$index, scope.row)"
              label="蓝海行动报名">
            </auth-button>
            <auth-button
              opt="join_oasis"
              class="btmBtn"
              type="text"
              v-if="scope.row.statusDesc === '审核通过' && scope.row.blueSeaStatus !== 3"
              :disabled="scope.row.oasisStatus === 1"
              @click.native="handleJoinOasis(scope.$index, scope.row)"
              label="绿洲计划报名">
            </auth-button> -->
            <auth-button
              opt="pos_refund"
              class="btmBtn"
              type="text"
              v-if="scope.row.posRefund === 0 && scope.row.transaction === 0"
              @click.native="openCardRefund(scope.row)"
              label="开启刷卡退款">
            </auth-button>
            <auth-button
              opt="open_cater"
              class="btmBtn"
              type="text"
              v-if="scope.row.merchantAppSource!= 1 && (scope.row.openCateringStatus === 0 || scope.row.professionalMarketFlag === 1 || scope.row.openCateringStatus === 2)"
              @click.native="goShowScanOrder(scope.row)"
              label="开启扫码点单">
            </auth-button>
            <auth-button
              opt="show_cater"
              class="btmBtn"
              type="text"
              v-if="scope.row.merchantAppSource!= 1 && scope.row.openCateringStatus === 1"
              @click.native="goViewScanOrder(scope.row)"
              label="查看扫码点单">
            </auth-button>
            <auth-button
              opt="show_cater"
              class="btmBtn"
              type="text"
              v-if="scope.row.isShowT0 && scope.row.t0OperateAuthority === 0"
              @click.native="goT0Settle(scope.row)"
              label="开启D0结算">
            </auth-button>
            <auth-button
              opt="show_cater"
              class="btmBtn"
              type="text"
              v-if="scope.row.isShowT0 && scope.row.t0OperateAuthority === 1"
              @click.native="goT0Settle(scope.row)"
              label="关闭D0结算">
            </auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total > 10000 ? 10000 : paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <wechat-form :to-set.sync="wxSetDialogVisible" :merchant-id="selectRowId" :payType="selectRowPayType"></wechat-form>
    <settle-form v-if="dialogSettleVisible" :visible.sync="dialogSettleVisible" :merchant-id="selectRowId" @submit="saveSettle" @close="(value)=>{dialogSettleVisible = value}"></settle-form>

    <join-blueSea :visible="blueSeaInfoDialogVisible" v-if="blueSeaInfoDialogVisible" :id="selectRowId" @submit="joinBlueSeaSuccess" @close="(value)=>{blueSeaInfoDialogVisible = value}"></join-blueSea>
    <join-oasis :visible="oasisInfoDialogVisible" v-if="oasisInfoDialogVisible" :id="selectRowId" @submit="joinOasisSuccess" @close="(value)=>{oasisInfoDialogVisible = value}"></join-oasis>

    <el-dialog
      title="证件更新"
      v-if="updateExpireDialogVisible"
      :visible.sync="updateExpireDialogVisible"
      width="810px"
      @close="getList"
      :close-on-click-modal="false">
      <iframe :src="h5Domain+'/illegalFundsIdentify/idExpirePc.html?merchantId=' + selectRowId +'&sessionId='+sessionId+'&userName='+userName" frameborder="0" style="height: 667px;width: 770px;"></iframe>
      <div style="text-align: right;margin-top: 20px">
        <el-button @click="updateExpireDialogVisible = false;getList()">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="isShowOpenScanOrderDialog"
      width="30%">
      <span>是否开通扫码点单？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowOpenScanOrderDialog = false">取 消</el-button>
        <el-button type="primary" @click="doOpenScanOrder">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="isShowOpenT0SettleDialog"
      width="30%">
      <span v-if='selectedT0Entity.t0OperateAuthority === 0'>是否开通D0结算？</span>
      <span v-else>是否关闭D0结算？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowOpenT0SettleDialog = false">取 消</el-button>
        <el-button type="primary" @click="doOpenT0Settle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import listSearch from '../components/chainListSearch'

import wechatForm from '../components/wechatForm'
import settleForm from '../components/settleForm'
import joinBlueSea from '../components/joinBlueSea'
import joinOasis from '../components/joinOasis'
import { openScanOrder, modifyMerchantTradeStatus, countCardExpireMerchant, updateRefundState, openT0Settle } from '@/api/merchant.js'
import { chainGetShopList } from '@/api/merchant-info.js'
export default {
  name: 'AllMerchant',
  components: {
    listSearch,
    // addShop,
    wechatForm,
    settleForm,
    joinBlueSea,
    joinOasis
  },
  data () {
    return {
      isShowOpenScanOrderDialog: false,
      isShowOpenT0SettleDialog: false,
      selectedRowEntity: {},
      selectedT0Entity: {},
      search_sale: {
        shopId: '', // 门店ID
        shopName: '', // 门店名称
        organizationName: '', // 上级机构名称
        organizationId: '', // 上级机构ID
        auditStatus: '', // 审核状态
        tradeStatus: '', // 交易状态
        settleStatus: '', // 结算状态
        pageNo: '',
        pageSize: '',
        totalCount: ''
      },
      agentId: '', // 用户id
      userName: '', // 用户名
      roleName: '', // 用户角色
      sessionId: '', //
      saleLoading: false, // 列表加载
      checkLoading: false, // 查询加载
      sale_list: [], // 列表数据
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      salesNum: '', // 列表商户总数量
      effect_privilege_level_list: [], // 商业等级列表
      selectRowId: '', // 当前操作行的商户id
      activeName: 'info',
      buttonLoading: false, // 按钮加载中
      changeTradeStateInfo: {
        operateType: '', // 交易状态开通65，冻结66
        reason: '', // 交易状态修改理由
        picUrl: ''
      },
      changeTradeStateRules: {
        operateType: [
          { required: true, message: '请选择要修改的交易状态', trigger: 'change' }
        ],
        reason: [
          { required: true, message: '请输入修改理由', trigger: 'blur' },
          { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' },
          { pattern: /^\S{1,50}$/, message: '修改理由不能超过50个字', trigger: 'blur' }
        ]
      },
      wxSetDialogVisible: false, // 微信公众号支付设置弹窗是否显示
      selectRowPayType: 1, // 选中行的业务类型，1线上，2线下
      dialogSettleVisible: false, // 结算卡编辑弹窗显示
      blueSeaInfoDialogVisible: false, // 蓝海弹窗
      oasisInfoDialogVisible: false, // 绿洲弹窗
      updateExpireDialogVisible: false, // 证件更新弹窗
      h5Domain: 'https://t-h5.lepass.cn/', // 请求h5域名
      hideExpireExport: true// 是否隐藏导出过期按钮
    }
  },
  mounted () {
    this.getUserInfo()
    this.getPrivileges()
    switch (process.env.CUSTOM_ENV) {
      case 'test': {
        this.h5Domain = 'https://t-h5.lepass.cn/'
        break
      }
      case 'pre': {
        this.h5Domain = 'https://p-h5.lepass.cn/'
        break
      }
      case 'prd': {
        this.h5Domain = 'https://h5.leshuazf.com/wap/'
        break
      }
      default: {
        this.h5Domain = 'https://t-h5.lepass.cn/'
      }
    }
    this.getList()
    this.hideExpireExport = !!window.localStorage.getItem('hide_' + this.agentId + '_ExpireExport')
  },
  methods: {

    /**
       * @description 商户等级列表获取
       */
    getPrivileges () {
      var con = JSON.parse(localStorage.privilegeConst)
      var compare = function (obj1, obj2) {
        var val1 = obj1.code
        var val2 = obj2.code
        if (val1 < val2) {
          return -1
        } else if (val1 > val2) {
          return 1
        } else {
          return 0
        }
      }
      this.effect_privilege_level_list = con.sort(compare)
    },
    /**
       * @description 获取用户信息
       */
    getUserInfo () {
      this.agentId = this.$store.getters.userId
      this.userName = this.$store.getters.userName
      this.sessionId = this.$store.state.user.sessionId
      this.roleName = this.$store.getters.roleName
    },
    /**
       * @description 修改列表排序
       * @param {String} val 排序控制对象
       */
    tableSortChange (val) {
      if (val.prop !== null) {
        if (val.order === 'descending') {
          this.search_sale.orderColumn = val.prop
          this.search_sale.orderType = 1
        } else {
          this.search_sale.orderColumn = val.prop
          this.search_sale.orderType = 0
        }
      }
      this.getList()
    },
    /**
       * @description 获取列表
       */
    async getList () {
      this.saleLoading = true
      try {
        const data = await chainGetShopList({
          ...this.search_sale,
          pageNo: this.paginations.pageNum,
          pageSize: this.paginations.pageSize
        })
        if (data.error_code !== '0') {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.paginations.total = data.data.totalCount
          this.sale_list = data.data.list
          this.sale_list.forEach(item => {
            item.t0SettleStr = item.t0Settle === 0 ? '否' : '是'
          })
          this.salesNum = data.data.totalCount
        }
      } catch (e) {
        var that = this
        that.$message({
          showClose: true,
          message: '请求超时，请重新登录',
          type: 'error'
        })
      } finally {
        this.saleLoading = false
        this.checkLoading = false
      }
    },
    /**
       * @description 商户等级根据编码查询名称
       */
    covertPrivilege (item) {
      for (var i = 0; i < this.effect_privilege_level_list.length; i++) {
        if (item.fPrivilegeLevel === this.effect_privilege_level_list[i].code) {
          return this.effect_privilege_level_list[i].name
        }
      }
    },
    /**
       * @description 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      this.paginations.pageNum = page
      this.getList()
    },
    /**
       * @description 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize1 (size) {
      var totalCount = this.salesNum
      var pageNo = this.paginations.pageNum
      this.search_sale.pageSize = size
      this.search_sale.pageNo = pageNo
      this.search_sale.Count = totalCount
      this.onSearch()
    },
    /**
       * @description 刷新列表，不改变页码等
       */
    onSearch () {
      this.checkLoading = true
      this.getList()
    },
    /**
       * @description 点击查询按钮事件
       */
    buttonSearch (data) {
      this.search_sale = data
      // 当点击查询时，显示第一页
      this.paginations.pageNum = 1
      this.onSearch()
    },
    /**
       * @description 清除对象中无值属性
       */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    //    表单操作
    /**
       * @description 微信公众号设置点击
       */
    handleWxSetClick (index, row) {
      this.selectRowId = row.fMerchantId
      this.selectRowPayType = parseInt(row.fPayType)
      this.wxSetDialogVisible = true// 设置微信公众号
    },
    /**
       * @description 关闭弹窗
       */
    closeViewDialog () {
      this.$refs.changeTradeStateform && this.$refs.changeTradeStateform.resetFields()
    },
    /**
       * @description 显示查看界面
       */
    handleSale (index, row, scope) {
      this.checkDialogVisible = true
      this.selectRowId = row.merchantId
      const query = {
        id: this.selectRowId,
        readOnly: '1',
        step: 3,
        isEdit: '0',
        shopId: row.shopId
      }
      this.$router.push({
        path: '/Merchant/SoftwareMerchant/chainDetails',
        query: query
      })
    },
    /**
       * @description 显示编辑界面
       */
    handleEditSale (index, row, scope) {
      this.selectRowId = row.merchantId
      const query = {
        id: this.selectRowId,
        readOnly: '0',
        isEdit: '1',
        step: 3,
        shopId: row.shopId
      }
      this.$router.push({
        path: '/Merchant/SoftwareMerchant/chainDetails',
        query: query
      })
    },
    /**
       * @description 显示结算卡编辑界面
       */
    settleCardEdit (index, row, scope) {
      this.dialogSettleVisible = true
      this.selectRowId = row.chainHeadMerchantId
    },
    /**
       * @description 新增门店成功
       */
    addShopSuccess () {
      this.addShopDialogVisible = false
      this.getList()
    },
    /**
       * @description 蓝海行动报名按钮点击
       */
    handleJoinBlueSea (index, row) {
      if (row.blueSeaStatus === 2) {
        this.$router.push({ path: `/Merchant/BlueSeaInfo/${row.fMerchantId}` })
        return
      }
      if (!row.fLicense) {
        this.$message({
          message: '请先补齐营业执照资料再申请蓝海行动',
          type: 'warning'
        })
        return
      }
      this.blueSeaInfoDialogVisible = true
      this.selectRowId = row.fMerchantId
    },
    /**
       * @description 绿洲计划报名按钮点击
       */
    handleJoinOasis (index, row) {
      if (row.oasisStatus === 2) {
        this.$router.push({ path: `/Merchant/OasisInfo/${row.fMerchantId}` })
        return
      }
      if (!row.fLicense) {
        this.$message({
          message: '请先补齐营业执照资料再申请绿洲计划',
          type: 'warning'
        })
        return
      }
      this.oasisInfoDialogVisible = true
    },

    /**
       * @description 状态控制确定点击
       */
    handleStateControlClick () {
      this.$refs.changeTradeStateform.validate(valid => {
        if (valid) {
          this.$confirm('对同一商户的操作一天仅限一次', '是否确认提交?', {
            type: 'warning'
          }).then(() => {
            this.modifyMerchantTradeStatus()
          })
        } else {
          this.$message({
            message: '提交信息有误，请完善后重新提交',
            type: 'error'
          })
          return false
        }
      })
    },
    /**
       * @description 一代代理商修改商户交易权限
       */
    modifyMerchantTradeStatus () {
      return new Promise((resolve, reject) => {
        this.buttonLoading = true
        const operator = this.$store.getters.userId
        let data = {
          operator: operator,
          merchantId: this.selectRowId
        }
        data = Object.assign({}, data, this.changeTradeStateInfo)
        const params = qs.stringify(data)
        modifyMerchantTradeStatus(params).then(response => {
          this.buttonLoading = false
          if (response.error_code === '200') {
            this.$message({
              showClose: true,
              message: response.error_msg,
              type: 'success'
            })
            this.editDialogVisible = false
          } else {
            this.$message({
              showClose: true,
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
       * @description 上传状态控制图片回调
       * @param {Object} data 回调数据对象
       */
    uploadSuccess (data) {
      const name = data.valueName
      this.changeTradeStateInfo[name] = data.path
    },
    /**
       * @description 保存结算卡修改回调
       * @param {Boolean} flag 是否修改成功
       */
    saveSettle (flag) {
      this.dialogSettleVisible = false
      if (flag) {
        this.getList()
      }
    },
    /**
       * @description 加入蓝海行动成功回调
       * @param {Boolean} result 是否加入成功
       */
    joinBlueSeaSuccess (result) {
      this.blueSeaInfoDialogVisible = false
      if (result) {
        this.onSearch()
      }
    },
    /**
       * @description 加入绿洲行动成功回调
       * @param {Boolean} result 是否加入成功
       */
    joinOasisSuccess (result) {
      this.oasisInfoDialogVisible = false
      if (result) {
        this.onSearch()
      }
    },

    /**
       * @description 检查身份证过期数量
       */
    checkIdExpire () {
      const that = this
      const date = new Date()
      const lastShowDate = new Date(parseInt(window.localStorage['show_' + this.agentId + '_ExpireTipsDate']))
      let notToday = false
      if (lastShowDate) {
        notToday = lastShowDate.getFullYear() !== date.getFullYear() || lastShowDate.getMonth() !== date.getMonth() || lastShowDate.getDate() !== date.getDate()
      }
      if (!lastShowDate || notToday) {
        window.localStorage.removeItem('show_' + this.agentId + '_ExpireTipsDate')
        window.localStorage.removeItem('hide_' + this.agentId + '_ExpireExport')
        const time = date.getTime()
        window.localStorage.setItem('show_' + this.agentId + '_ExpireTipsDate', time)
        const data = qs.stringify({})
        countCardExpireMerchant(data).then(response => {
          if (parseInt(response.error_code) === 0) {
            if (response.count !== 0) {
              const count = response.count
              that.$confirm('<p>' + count + '个商户的身份证件将在30天内过期，请及时更新商户身份证。证件过期的商户，可以在商户>所有商户>导出证件过期商户列表 进行导出，如未及时更新，将会进行<span style="color: red">限额</span>或<span style="color: red">暂停交易</span>。</p>', '证件更新', {
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
                confirmButtonText: '我已知悉'
              }).then(() => {})
            } else {
              window.localStorage.setItem('hide_' + this.agentId + '_ExpireExport', true)
              that.hideExpireExport = true
            }
          } else if (parseInt(response.error_code) !== 1) {
            this.$message({
              message: response.error_msg,
              type: 'warning'
            })
          }
        })
      }
    },
    goShowScanOrder (row) {
      this.selectedRowEntity = Object.assign({}, row)
      this.isShowOpenScanOrderDialog = true
    },
    doOpenScanOrder () {
      openScanOrder(qs.stringify({
        merchantId: this.selectedRowEntity.fMerchantId
      })).then(response => {
        if (response.error_code === '0') {
          this.$message({
            showClose: true,
            message: '开通成功',
            type: 'success'
          })
          this.isShowOpenScanOrderDialog = false
          this.onSearch()
        } else {
          this.$message({
            showClose: true,
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    goT0Settle (row) {
      this.selectedT0Entity = Object.assign({}, row)
      this.isShowOpenT0SettleDialog = true
    },
    doOpenT0Settle () {
      const param = {
        merchantId: this.selectedT0Entity.fMerchantId,
        t0SettlementState: this.selectedT0Entity.t0OperateAuthority === 0 ? 1 : 0
      }
      openT0Settle(qs.stringify(param)).then(response => {
        if (response.error_code === '0') {
          this.$message({
            showClose: true,
            message: this.selectedT0Entity.t0OperateAuthority === 0 ? '开通成功' : '关闭成功',
            type: 'success'
          })
          this.isShowOpenT0SettleDialog = false
          this.onSearch()
        } else {
          this.$message({
            showClose: true,
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    goViewScanOrder (row) {
      let url = ''
      const token = localStorage.getItem('ZZGAgentToken')
      const merchantInfo = {
        shopId: row.shopId, // 门店id
        shopName: row.shopName, // 门店名称
        industry: row.industry, // 行业
        legalPersonName: row.fLegalName, // 法人姓名
        legalPersonPhone: row.fLegalMobile, // 法人手机
        shopStateName: row.statusDesc, // 门店状态
        registryTime: row.fcreateTime, // 注册时间
        agentName: row.fAgentName, // 代理商
        agentNo: row.fAgentId, // 代理商编号
        operatorName: row.fOperatorName // 业务员
      }
      const origin = 'ZZGAgentOrigin'
      if (process.env.CUSTOM_ENV === 'dev') {
        url = `https://d-h5.lszzg.com/zzg-operate-system/#/merchant-details?token=${token}&merchantInfo=${JSON.stringify(merchantInfo)}&origin=${origin}`
      } else if (process.env.CUSTOM_ENV === 'test') {
        url = `https://t-h5.lszzg.com/zzg-operate-system/#/merchant-details?token=${token}&merchantInfo=${JSON.stringify(merchantInfo)}&origin=${origin}`
      } else if (process.env.CUSTOM_ENV === 'pre') {
        url = `https://p-h5.lszzg.com/zzg-operate-system/#/merchant-details?token=${token}&merchantInfo=${JSON.stringify(merchantInfo)}&origin=${origin}`
      } else if (process.env.CUSTOM_ENV === 'prd') {
        url = `https://zzgfs.lszzg.com/zzg-operate-system/#/merchant-details?token=${token}&merchantInfo=${JSON.stringify(merchantInfo)}&origin=${origin}`
      } else {
        url = `https://d-h5.lszzg.com/zzg-operate-system/#/merchant-details?token=${token}&merchantInfo=${JSON.stringify(merchantInfo)}&origin=${origin}`
      }
      window.open(url)
    },
    openCardRefund (row) {
      const that = this
      this.$confirm('开启刷卡退款权限需关闭刷卡T0交易结算权限，是否同意？', '温馨提醒').then(() => {
        const params = qs.stringify({
          merchantId: row.merchantId
        })
        updateRefundState(params).then((res) => {
          if (res.error_code === '0') {
            that.$message({
              message: '开启成功！',
              type: 'success'
            })
            that.onSearch()
          } else {
            this.$message({
              showClose: true,
              message: res.error_msg,
              type: 'error'
            })
          }
        })
      })
    }
  }
}
</script>

<style scoped>
  .list{
    padding-left: 16px;
  }
  .btm-action {
    margin: 20px 0;
    text-align: center;
  }
  .pagination {
    display: inline-block;
  }
  .btmBtn{
    margin-top: 10px;
  }
</style>
